export const receiptTaxinvoice = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "reference": "PO20210300001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "receivedBy": "สมชาย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000
}

export const taxInvoice = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "dueDate": "2021-04-23T14:50:21.073Z",
    "dueDateBE": "23/04/2564",
    "dueDateCE": "23/04/2021",
    "reference": "PO20210300001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "createdBy": "สมชาย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000
}

export const receiptTaxinvoiceAbb = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true
    },
    "customer": {
        "name": null,
        "buildingNumber": null,
        "address": null,
        "streetPrefix": null,
        "streetName": null,
        "branchNumber": null,
        "branchText": null,
        "subDistrictPrefix": null,
        "subDistrictCode": null,
        "subDistrictName": null,
        "districtPrefix": null,
        "districtCode": null,
        "districtName": null,
        "provincePrefix": null,
        "provinceCode": null,
        "provinceName": null,
        "postcode": null,
        "countryCode": null,
        "countryName": null,
        "taxNumberType": null,
        "taxId": null,
        "phoneCountryCode": null,
        "phone": null,
        "email": null,
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "receivedBy": "สมชาย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000
}

export const receipt = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "reference": "PO20210300001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "receivedBy": "สมชาย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000
}

export const debitNote = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
    },
    "date": "2021-03-20T15:36:04.835Z",
    "dateBE": "20/03/2564",
    "dateCE": "20/03/2021",
    "number": "TIV20210100001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 1000,
            "total": 1000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 1000,
    "vatTotal": 69.3,
    "grandTotal": 1059.3,
    "grandTotalTH": "หนึ่งพันห้าสิบเก้าบาท สามสิบสตางค์",
    "grandTotalEN": "one thousand fifty nine baht thirty satang",
    "note": "ทดสอบหมายเหตุ",
    "createdBy": "สมชาย",
    "refer": {
        "typeCode": "T03",
        "typeName": "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        "number": "RCT-TIV-0001",
        "date": "2021-03-17T17:00:00.000Z",
        "dateBE": "18/03/2564",
        "dateCE": "18/03/2021",
        "reasonCode": "DBNG99",
        "reasonName": "เหตุอื่น (ระบุสาเหตุ กรณีขายสินค้า)",
        "specificReason": "ทดสอบสาเหตุ",
        "amountTotal": 10,
        "diffAmountTotal": 990
    },
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 990
}

export const creditNote = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
    },
    "date": "2021-03-20T15:36:04.835Z",
    "dateBE": "20/03/2564",
    "dateCE": "20/03/2021",
    "number": "TIV20210100001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 1000,
            "total": 1000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 1000,
    "vatTotal": 69930,
    "grandTotal": 1068930,
    "grandTotalTH": "หนึ่งล้านหกหมื่นแปดพันเก้าร้อยสาทสิบบาทถ้วน",
    "grandTotalEN": "one million sixty eight thousand nine hundred thirty baht",
    "note": "ทดสอบหมายเหตุ",
    "createdBy": "สมชาย",
    "refer": {
        "typeCode": "T03",
        "typeName": "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        "number": "RCT-TIV-0001",
        "date": "2021-03-17T17:00:00.000Z",
        "dateBE": "18/03/2564",
        "dateCE": "18/03/2021",
        "reasonCode": "CDNG99",
        "reasonName": "เหตุอื่น (ระบุสาเหตุ กรณีขายสินค้า)",
        "specificReason": "ทดสอบสาเหตุ",
        "amountTotal": 1000000,
        "diffAmountTotal": 999000
    },
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 999000
}

export const quotation = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "createdBy": "ผู้ขาย ร่ำรวย",
        "registerVat": true,
        "payment": {
            "display": true,
            "accountName": "บริษัท ทดสอบ จำกัด",
            "banks": [
                {
                    "accountNumber": "1234567890",
                    "bankCode": "KBANK",
                    "bankName": "ธนาคารกสิกรไทย",
                    "branch": "สยามพารากอน",
                    "typeCode": "SAVING",
                    "typeName": "ออมทรัพย์"
                },
                {
                    "accountNumber": "1234567890",
                    "bankCode": "SCB",
                    "bankName": "ธนาคารไทยพาณิชย์",
                    "branch": "สยามพารากอน",
                    "typeCode": "CURRENT",
                    "typeName": "กระแสรายวัน"
                }
            ],
            "note": "หลังจากชำระเงินแล้ว กรุณาโทรแจ้งที่เบอร์ 081-234-5678",
            "promptpay": true,
            "promptpayQr": "data:image/png;base64,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"

        }
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
        "contactPerson": "ผู้ซื้อ ร่ำรวย"
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "paidTotal": 10700,
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "createdBy": "ผู้ขาย ร่ำรวย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000,
    "whtTotal": 0

}

export const invoice = {
    "company": {
        "name": "บริษัท ผู้ขายทดสอบ จำกัด",
        "buildingNumber": "999",
        "address": "หมู่ 999",
        "streetPrefix": "ถ.",
        "streetName": "สาทร 999",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "taxNumberType": "TXID",
        "taxId": "1234567890999",
        "phoneCountryCode": "+66",
        "phone": "0912345678",
        "email": "seller@test.com",
        "registerVat": true,
        "payment": {
            "display": true,
            "accountName": "บริษัท ทดสอบ จำกัด",
            "banks": [
                {
                    "accountNumber": "1234567890",
                    "bankCode": "KBANK",
                    "bankName": "ธนาคารกสิกรไทย",
                    "branch": "สยามพารากอน",
                    "typeCode": "SAVING",
                    "typeName": "ออมทรัพย์"
                },
                {
                    "accountNumber": "1234567890",
                    "bankCode": "SCB",
                    "bankName": "ธนาคารไทยพาณิชย์",
                    "branch": "สยามพารากอน",
                    "typeCode": "CURRENT",
                    "typeName": "กระแสรายวัน"
                }
            ],
            "note": "หลังจากชำระเงินแล้ว กรุณาโทรแจ้งที่เบอร์ 081-234-5678",
            "promptpay": true,
            "promptpayQr": "data:image/png;base64,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"

        }
    },
    "customer": {
        "name": "บริษัท ลูกค้าทดสอบ จำกัด",
        "buildingNumber": "99",
        "address": "หมู่ที่ 99",
        "streetPrefix": "ถนน",
        "streetName": "สาทร 99",
        "branchNumber": "00000",
        "branchText": "สำนักงานใหญ่",
        "subDistrictPrefix": "แขวง",
        "subDistrictCode": "100402",
        "subDistrictName": "สีลม",
        "districtPrefix": "เขต",
        "districtCode": "1004",
        "districtName": "บางรัก",
        "provincePrefix": "",
        "provinceCode": "10",
        "provinceName": "กรุงเทพมหานคร",
        "postcode": "10500",
        "countryCode": "TH",
        "countryName": "ไทย",
        "taxNumberType": "TXID",
        "taxId": "1234567890123",
        "phoneCountryCode": "+66",
        "phone": "0812345678",
        "email": "buyer@test.com",
        "contactPerson": "ผู้ซื้อ ร่ำรวย"
    },
    "date": "2021-03-23T14:50:21.073Z",
    "dateBE": "23/03/2564",
    "dateCE": "23/03/2021",
    "number": "TIV20210300001",
    "paidTotal": 10700,
    "dueDate": "2021-04-23T14:50:21.073Z",
    "dueDateBE": "23/04/2564",
    "dueDateCE": "23/04/2021",
    "reference": "PO20210300001",
    "items": [
        {
            "number": "1",
            "description": "ค่าสินค้า",
            "quantity": 1,
            "unitCode": "",
            "unitName": "",
            "price": 10000,
            "total": 10000,
            "discount": 0,
            "percentVat": 7,
            "percentVatText": "7%",
        }
    ],
    "percentVat": 7,
    "amountTotal": 10000,
    "vatTotal": 700,
    "grandTotal": 10700,
    "grandTotalTH": "หนึ่งหมื่นเจ็ดร้อยบาทถ้วน",
    "grandTotalEN": "one thousand seven hundred baht",
    "note": "ทดสอบหมายเหตุ",
    "createdBy": "ผู้ขาย ร่ำรวย",
    "reIssue": false,
    "discount": 0,
    "nonVatPriceTotal": 0,
    "zeroVatPriceTotal": 0,
    "vatPriceTotal": 10000,
    "whtTotal": 0

}

